import { render, staticRenderFns } from "./VideoWindow.vue?vue&type=template&id=01608633&scoped=true"
import script from "./VideoWindow.vue?vue&type=script&lang=js"
export * from "./VideoWindow.vue?vue&type=script&lang=js"
import style0 from "./VideoWindow.vue?vue&type=style&index=0&id=01608633&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01608633",
  null
  
)

export default component.exports